// @flow

import type { Action } from '../store.type';

export const GET_CHECKLIST_REQUEST = 'GET_CHECKLIST_REQUEST';
type GET_CHECKLIST_REQUEST_TYPE = 'GET_CHECKLIST_REQUEST';

export const GET_CHECKLIST_SUCCESS = 'GET_CHECKLIST_SUCCESS';
type GET_CHECKLIST_SUCCESS_TYPE = 'GET_CHECKLIST_SUCCESS';

export const GET_CHECKLIST_FAILURE = 'GET_CHECKLIST_FAILURE';
type GET_CHECKLIST_FAILURE_TYPE = 'GET_CHECKLIST_FAILURE';

export const SELECT_CHECKLIST_REQUEST = 'SELECT_CHECKLIST_REQUEST';
type SELECT_CHECKLIST_REQUEST_TYPE = 'SELECT_CHECKLIST_REQUEST';

export const SELECT_CHECKLIST_SUCCESS = 'SELECT_CHECKLIST_SUCCESS';
type SELECT_CHECKLIST_SUCCESS_TYPE = 'SELECT_CHECKLIST_SUCCESS';

export const SELECT_CHECKLIST_FAILURE = 'SELECT_CHECKLIST_FAILURE';
type SELECT_CHECKLIST_FAILURE_TYPE = 'SELECT_CHECKLIST_FAILURE';

export const SKIP_ACTION_ON_CHECKLIST_REQUEST = 'SKIP_ACTION_ON_CHECKLIST_REQUEST';
type SKIP_ACTION_ON_CHECKLIST_REQUEST_TYPE = 'SKIP_ACTION_ON_CHECKLIST_REQUEST';

export const SKIP_ACTION_ON_CHECKLIST_SUCCESS = 'SKIP_ACTION_ON_CHECKLIST_SUCCESS';
type SKIP_ACTION_ON_CHECKLIST_SUCCESS_TYPE = 'SKIP_ACTION_ON_CHECKLIST_SUCCESS';

export const SKIP_ACTION_ON_CHECKLIST_FAILURE = 'SKIP_ACTION_ON_CHECKLIST_FAILURE';
type SKIP_ACTION_ON_CHECKLIST_FAILURE_TYPE = 'SKIP_ACTION_ON_CHECKLIST_FAILURE';

export const TRACK_EVENT_REQUEST = 'TRACK_EVENT_REQUEST';
type TRACK_EVENT_REQUEST_TYPE = 'TRACK_EVENT_REQUEST';

export const TRACK_EVENT_SUCCESS = 'TRACK_EVENT_SUCCESS';
type TRACK_EVENT_SUCCESS_TYPE = 'TRACK_EVENT_SUCCESS';

export const TRACK_EVENT_FAILURE = 'TRACK_EVENT_FAILURE';
type TRACK_EVENT_FAILURE_TYPE = 'TRACK_EVENT_FAILURE';

type ChecklistSuccess = {
  data: Object
};

type ChecklistFailure = {
  error: any
};

type GetChecklistRequestAction = Action<GET_CHECKLIST_REQUEST_TYPE, null>;

type GetChecklistSuccessAction = Action<GET_CHECKLIST_SUCCESS_TYPE, ChecklistSuccess>;

type GetChecklistFailureAction = Action<GET_CHECKLIST_FAILURE_TYPE, ChecklistFailure>;

type SelectChecklistRequestAction = Action<SELECT_CHECKLIST_REQUEST_TYPE, null>;

type SelectChecklistSuccessAction = Action<SELECT_CHECKLIST_SUCCESS_TYPE, ChecklistSuccess>;

type SelectChecklistFailureAction = Action<SELECT_CHECKLIST_FAILURE_TYPE, ChecklistFailure>;

type SkipActionOnChecklistRequestAction = Action<SKIP_ACTION_ON_CHECKLIST_REQUEST_TYPE, null>;

type SkipActionOnChecklistSuccessAction = Action<
  SKIP_ACTION_ON_CHECKLIST_SUCCESS_TYPE,
  ChecklistSuccess
>;

type SkipActionOnChecklistFailureAction = Action<
  SKIP_ACTION_ON_CHECKLIST_FAILURE_TYPE,
  ChecklistFailure
>;

type TrackEventRequestAction = Action<TRACK_EVENT_REQUEST_TYPE, null>;

type TrackEventSuccessAction = Action<TRACK_EVENT_SUCCESS_TYPE, ChecklistSuccess>;

type TrackEventFailureAction = Action<TRACK_EVENT_FAILURE_TYPE, ChecklistFailure>;

type ChecklistActionType = {
  step: number,
  eventSource: string,
  eventName: string,
  description: string,
  linkText: string,
  linkPath: string,
  completed: boolean
};

export type GetChecklistState = {
  loading: boolean,
  success: boolean,
  selectChecklistLoading: boolean,
  selectChecklistSuccess: boolean,
  skipActionLoading: boolean,
  skipActionSuccess: boolean,
  trackEventLoading: boolean,
  trackEventSuccess: boolean,
  error: any,
  completed: number,
  total: number,
  actions: Array<ChecklistActionType>
};

export type ChecklistActions =
  | GetChecklistRequestAction
  | GetChecklistSuccessAction
  | GetChecklistFailureAction
  | SelectChecklistRequestAction
  | SelectChecklistSuccessAction
  | SelectChecklistFailureAction
  | SkipActionOnChecklistRequestAction
  | SkipActionOnChecklistSuccessAction
  | SkipActionOnChecklistFailureAction
  | TrackEventRequestAction
  | TrackEventSuccessAction
  | TrackEventFailureAction;
